module.exports = __webpack_public_path__ + "img/crystal-palace-logo-icon.fe8a4b8e.png";